import { createFileRoute } from "@tanstack/react-router";
import { MembersSettingsPage } from "../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/members")({
  component: MembersSettingsPage,
});
